module.exports = __webpack_public_path__ + "img/pic-other2.72b2e8ac.jpg";